export default __webpack_public_path__ + "static/media/download-apple-fr.cef12ac8.png";